export default function formatFileSize(
  bytes
) {

  if (!bytes)
    return "0 B";

  const sizes = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB"
  ];

  const i =
    Math.floor(
      Math.log(bytes) /
      Math.log(1024)
    );

  return `${(
    bytes /
    Math.pow(
      1024,
      i
    )
  ).toFixed(2)} ${
    sizes[i]
  }`;

}



export function formatDate(date) {

    if (!date)
        return "-";

    return new Date(date)
        .toLocaleDateString();

}